import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { EbsWebServiceGlobals } from "../../../services/ebsWebServiceGlobals";
import { EbsWebService } from "../../../services/ebsWebService";

@Component({
  selector: 'page-customdetail',
  templateUrl: 'customdetail.html',
  providers: [
    EbsWebService,
    EbsWebServiceGlobals
  ]
})
export class CustomDetail {

  title: string;
  actionURL: string;
  options: Object;
  mainNavigationObjects: any;

  headerChart: string;
  subHeaderChart: string;
  gesamtChart: any;
  rueckfuehrungChart: any;
  rueckfuehrungChartProzent: any;
  offenChart: any;
  offenChartProzent: any;
  lableName1: any;
  lableName2: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private _ebsWebService: EbsWebService,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals) {

    this.title = this.navParams.get('title');
    this.actionURL = this.navParams.get('actionURL');

    this.mainNavigationObjects = this._ebsWebService.postData(this.actionURL,null);
    this.mainNavigationObjects.subscribe(res => {

      this.headerChart = res.ListItemNavigation[0].ListItemContent[0].DisplayText;
      this.subHeaderChart = res.ListItemNavigation[0].ListItemContent[1].DisplayText;
      this.gesamtChart = res.ListItemNavigation[0].ListItemContent[2].DisplayText;
      this.rueckfuehrungChart = res.ListItemNavigation[0].ListItemContent[3].DisplayText;
      this.lableName1 = res.ListItemNavigation[0].ListItemContent[3].FieldName;
      this.offenChart = res.ListItemNavigation[0].ListItemContent[4].DisplayText;
      this.lableName2 = res.ListItemNavigation[0].ListItemContent[4].FieldName;

      this.rueckfuehrungChartProzent = (this.rueckfuehrungChart*100)/this.gesamtChart;
      this.offenChartProzent = (this.offenChart*100)/this.gesamtChart;

      this.options = {
        colors: ['#000000', '#D4AF37'],
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            backgroundColor: '#f7f7f7',
            renderTo: 'chartcontainer',
            margin: [0, 0, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0
        },
        title: {
            text: this.headerChart
        },
        subtitle: {
            text: this.subHeaderChart
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: false
                },
                showInLegend: true,
                size: 230
            }
        },
        series: [{
            name: 'Gesamt',
            colorByPoint: true,
            data: [{
                name: this.lableName1,
                y: this.rueckfuehrungChartProzent
            }, {
                name: this.lableName2,
                y: this.offenChartProzent,
                sliced: true,
                selected: true
            }]
        }]
      };
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/custom/customdetail/customdetail.ts